import {useLocalStorage_DEPRECATED} from '@aboutyou/storage';
import {useEffect} from 'react';
import {v4 as uuidv4} from 'uuid';

export const UUID_LOCAL_STORAGE_KEY = 'ay_id_push';

export const useBrowserSpecificUUID = () => {
  // eslint-disable-next-line no-restricted-syntax
  const [browserUUID, setBrowserUUID] = useLocalStorage_DEPRECATED<
    string | undefined
  >({
    key: UUID_LOCAL_STORAGE_KEY,
    defaultValue: undefined,
  });

  useEffect(() => {
    if (!browserUUID) {
      // eslint-disable-next-line local-rules/set-state-in-use-effect -- TODO: Cleanup setState in useEffect https://aboutyou.atlassian.net/browse/ASFE-7602
      setBrowserUUID(uuidv4());
    }
  }, [browserUUID, setBrowserUUID]);

  return browserUUID ?? '';
};
